/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultOrder } from '../../models/api-response-paged-result-order';
import { PagedRequestOrderFilterRequest } from '../../models/paged-request-order-filter-request';

export interface GetOrder$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestOrderFilterRequest
}

export function getOrder(http: HttpClient, rootUrl: string, params: GetOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultOrder>> {
  const rb = new RequestBuilder(rootUrl, getOrder.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultOrder>;
    })
  );
}

getOrder.PATH = '/v1/api/orders/order-effectue';
